import { render, staticRenderFns } from "./faceIdentify.vue?vue&type=template&id=11f6ecd2&scoped=true&"
import script from "./faceIdentify.vue?vue&type=script&lang=js&"
export * from "./faceIdentify.vue?vue&type=script&lang=js&"
import style0 from "./faceIdentify.vue?vue&type=style&index=0&id=11f6ecd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f6ecd2",
  null
  
)

export default component.exports